import { Box, Group, Text } from '@mantine/core';
import { IconFile } from '@tabler/icons-react';
import { ReactElement, ReactNode } from 'react';
import { formatFileSize } from '@/services/attachments';

const RULE = '1px solid #e9ecef';

/**
 * One file as a row (BAR-3078), in the two styles the coverage prototype draws
 * (`orbit-timeline-employer-card.html`): `compose`, a file picked in a composer (`.frow`:
 * a 40px grey thumb), and `card`, a file recorded on a timeline card (`.doc`: a red file icon,
 * at most 520px). Its actions (remove, or view and download) go on the right.
 */
export function AttachmentRow({
  name,
  size,
  variant,
  actions,
}: {
  name: string;
  /** Bytes. */
  size?: number;
  variant: 'compose' | 'card';
  actions?: ReactNode;
}): ReactElement {
  const compose = variant === 'compose';
  return (
    <Group
      gap={10}
      wrap="nowrap"
      style={{
        border: RULE,
        borderRadius: 8,
        padding: compose ? '6px 8px' : '6px 10px',
        maxWidth: compose ? undefined : 520,
      }}
    >
      {compose ? (
        <Box
          w={40}
          h={40}
          style={{
            borderRadius: 6,
            background: '#f8f9fa',
            color: '#868e96',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <IconFile size={18} />
        </Box>
      ) : (
        <IconFile size={16} color="#C9201A" style={{ flexShrink: 0 }} />
      )}
      <Text fz={14} fw={500} truncate style={{ flex: 1, minWidth: 0 }}>
        {name}
      </Text>
      {size !== undefined && (
        <Text fz={compose ? 10 : 11} c="dimmed" style={{ flexShrink: 0 }}>
          {formatFileSize(size)}
        </Text>
      )}
      {actions && (
        <Group gap={8} wrap="nowrap" c="#868e96" style={{ flexShrink: 0 }}>
          {actions}
        </Group>
      )}
    </Group>
  );
}
